import { createSelector } from "reselect";
import { AppState } from "../../../../store";

export const SeoSelector = (state: AppState) => state.seoPage;

export const resultsSelector = createSelector(
  SeoSelector,
  (item) => item?.results || {}
);
export const lobDataSelector = createSelector(
  SeoSelector,
  (item) => item?.hideLob || false
);
export const reviewsSelector = createSelector(
  SeoSelector,
  (item) => item?.reviews || []
);
export const staticRentalDetails = createSelector(
  SeoSelector,
  (item) => item?.static_rental_data || []
);
export const staticTableDetails = createSelector(
  SeoSelector,
  (item) => item?.static_table_data || []
);
export const staticRentalTableDetails = createSelector(
  SeoSelector,
  (item) => item?.static_rental_table_data || []
);
export const aggregateRatingSelector = createSelector(
  SeoSelector,
  (item) => item?.aggregate_ratings || {}
);
export const minFareSchemaSelector = createSelector(
  SeoSelector,
  (item) => item?.schema_min_fare || -1
);
export const seoPageNameSelector = createSelector(
  SeoSelector,
  (item) => item?.seoPageName || ''
);
export const dynamicFooterDetailsSelector = createSelector(
  SeoSelector, 
  (item) => item?.dynamic_footer_data || []
);
export const waySelector = createSelector(
  SeoSelector,
  (item) => item?.way || ''
);
export const faqSelector = createSelector(
  SeoSelector,
  (item) => item?.faq || {}
);
export const seoFilterSelector = createSelector(
  resultsSelector,
  (item) => item?.filter_data || {}
);
export const commonSelector = createSelector(
  resultsSelector,
  (item) => item?.common_data || {}
);
export const seoVehicledataSelector = createSelector(
  resultsSelector,
  (item) => item?.vehicle_data || []
);
export const seoFilteredVehicleDataSelector = createSelector(
  resultsSelector,
  (item) => item?.filtered_vehicle_data || []
);
export const seoSelectedFilterSelector = createSelector(
  SeoSelector,
  (item) => item?.filters || {}
);
export const topRoutesFromSourceSelector = createSelector(
  SeoSelector,
  (item) => item?.top_routes_from_src || []
);
export const topRoutesFromSourceTitleSelector = createSelector(
  SeoSelector,
  (item) => item?.top_routes_from_src_title || ""
);
export const topRoutesToDestinationSelector = createSelector(
  SeoSelector,
  (item) => item?.top_routes_to_dest || []
);
export const topRoutesToDestinationTitleSelector = createSelector(
  SeoSelector,
  (item) => item?.top_routes_to_dest_title || ""
);
export const rentalDataSelector = createSelector(
  SeoSelector,
  (item) => item?.rental_data || []
);
export const routeInfoDataSelector = createSelector(
  SeoSelector,
  (item) => item?.route_info || {title: '', table: []}
);
export const dispatchSelector = createSelector(
  commonSelector,
  (item) => item?.dispatch_search_id || ""
);
export const rydeDispatchSearchIdSelector = createSelector(
  commonSelector,
  (item) => item?.ryde_dispatch_search_id || ""
);
export const isFilterAppliedSelector = createSelector(
  SeoSelector,
  (item) => item?.isFilterApplied || false
);
export const seoErrorSelector = createSelector(
  resultsSelector,
  (item) => {
    const { response } = item;
    const { common_data = {} } = response || item;
    const { error = {} } = common_data;
    return error || {};
  }
);
export const interlinkingSelector = createSelector(
  SeoSelector,
  (item) => item?.interlinking || []
);
export const SeoMetaSelector = createSelector(
  SeoSelector,
  (item) => item?.seo_meta || {}
);
export const breadCrumbsSelector = createSelector(
  SeoMetaSelector,
  (item) => item?.breadcrumb || []
);
export const seoBenefitsDataSelector = createSelector(
  SeoSelector,
  (item) => item?.benefits || {}
);
export const lpgSelector = createSelector(
  SeoSelector,
  (item) => item?.lpg || {}
);
export const placeInformationSelector = createSelector(
  SeoSelector,
  (item) => item?.place_information || ""
);
export const seoContentSelector = createSelector(
  SeoSelector,
  (item) => item?.seo_content || ""
);
export const templatizedContentSelector = createSelector(
  SeoSelector,
  (item) => item?.templatized_content || ""
);
export const airportTypeSelector = createSelector(
  SeoSelector,
  (item) => item?.airportType || ""
);

export const destinationSelector = createSelector(
  SeoSelector,
  (item) => item?.dest || ""
);

export const sourceSelector = createSelector(
  SeoSelector,
  (item) => item?.src || ""
);

export const queryFieldsSelector = createSelector(
  SeoSelector,
  (item) => item?.queryFields || []
);

export const showSEOLeadgenSelector = createSelector(
  SeoSelector,
  (item) => item?.showSEOLeadgen || false
);

export const showLeaveIntentSelector = createSelector(
  SeoSelector,
  (item) => item?.showSEOLeaveIntentForm || false
)

export const seoFormCouponSelector = createSelector(
  SeoSelector,
  (item) => item?.seoFormCouponData || null
)

export const startDateSelector = createSelector(
  SeoSelector,
  (item) => item?.startDate || ''
);
export const pageTypeSelector = createSelector(SeoSelector,(item)=>item?.pageType || '')
export const seoCarTypeSelector = createSelector(SeoSelector,(item)=>item?.car_type || '')
export const isSeoMulticitySelector = createSelector(SeoSelector,(item)=> item?.seo_multi_city || false)
export const seoInboundCallSelector = createSelector(SeoSelector, (item)=>item?.showInboundCall || false);
export const seoInboundContactNumber = createSelector(SeoSelector, (item) => item?.contactNumber || '');
export const seoCharDhamSelector = createSelector(SeoSelector, (item) => item?.charDhamData || {});
